import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {ParamsModelTable} from '../models/Table'
import {PakingListeThermoboardModel, ThermoBoardNalozi} from '../models/ThermoBoardNalozi'
import {ThermoBoardPaketiModel} from '../models/ThermoBoardPaketi'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/thermoboard/nalozi`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAllNalozi(params: ParamsModelTable) {
  return await axios.get<Array<ThermoBoardNalozi>>(API, {headers: headers, params: params})
}

export async function saveTBNalog(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchTBNalog(Id: number): Promise<Partial<ThermoBoardNalozi>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    return response.data.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateTBNalog(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteTBNalog(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error deleting data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getAllPaketiThermoboard(params: any) {
  return await axios.get<Array<ThermoBoardPaketiModel>>(`${API_URL}/thermoboard/getAllPaketi`, {
    headers: headers,
    params: params,
  })
}

export async function getPakingListeThermoboard(params: any) {
  return await axios.get<Array<PakingListeThermoboardModel>>(
    `${API_URL}/thermoboard/getPakingListe`,
    {
      headers: headers,
      params: params,
    }
  )
}
